/**
 * Servicios
 */
//Importar el espacio de almacenamiento de base de datos firestore
import { pacientesStore, logCollection } from '../firebase/config';

/**
 * Función que registra la solicitud dealteración a la colección surgeryroom
 * @param {Object} paciente Se recibe el paciente que sufrio la alteración
 * @param {String} userid Se recibe el identificador del usuario que hizo la actualización
 * @param {String} username Se recibe el nombre del usuario que realizó la actualización
 * @param {String} action Se recibe la actualización que se le aplico al usuario
 * @param {String} date Se recibe la fecha en que se realizó la alteración en formato yyyy-mm-dd
 * @param {String} time Se recibe la hora en que se realizó la alteración en formato hh:mm:ss:mil
 */
export const createLog = (paciente, userid, username, action, date, time, lastEstatus, IsInOperacion) => {
    try{
        pacientesStore
        .collection(logCollection)
        .add({
            paciente:       paciente,
            userid:         userid,
            username:       username,
            action:         action,
            date:           date,
            time:           time,
            lastEstatus:    lastEstatus,
            IsInOperacion : IsInOperacion
        })
    }
    catch{
        console.log('error')
    }
}